<label class="text-sm font-medium text-gray-900 dark:text-gray-300 cursor-pointer">
  <input type="checkbox"
         [id]="id()"
         [checked]="checked()"
         [disabled]="disabled()"
         (change)="onCheckboxChange($event)"
         [required]="required()"
         class="w-4 h-4 text-brand bg-gray-100 border-gray-300 rounded-sm focus:ring-brand dark:focus:ring-brand dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
  {{ label() }}
</label>
